module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/TV#2-d6ec345d6c72ccd1b9c36b2d225a30bd.svg";